import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PROCESS } from "@/data/site";
import { SectionHeading } from "@/components/pp/Shared";

export default function Process() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const lineW = useTransform(scrollYProgress, [0.1, 0.85], ["0%", "100%"]);

  return (
    <section id="process" className="relative py-24 md:py-32" data-testid="process">
      <div className="pp-container">
        <SectionHeading overline="How We Work" title="From First Idea to Final Impact" testid="process-heading" />

        <div ref={ref} className="relative">
          {/* horizontal beam (desktop) */}
          <div className="hidden lg:block absolute top-[46px] left-0 right-0 h-[2px] bg-white/8" />
          <motion.div style={{ width: lineW }}
            className="hidden lg:block absolute top-[46px] left-0 h-[2px]"
            aria-hidden="true">
            <div className="h-full w-full relative" style={{ background: "linear-gradient(90deg,#f59e0b,#ec4899,#8b5cf6,#06b6d4)" }}>
              <span className="absolute right-0 -top-1 h-3 w-3 rounded-full bg-white shadow-[0_0_16px_#f59e0b]" />
            </div>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-8 lg:gap-4">
            {PROCESS.map((p, i) => (
              <motion.div key={p.step}
                initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.6, delay: i * 0.08 }}
                className="relative" data-testid={`process-step-${p.step}`}
              >
                <div className="relative z-[1] h-[92px] w-[92px] mx-auto lg:mx-0 rounded-full pp-glass grid place-items-center font-display text-3xl text-[#f59e0b] mb-6">
                  {p.step}
                </div>
                <h3 className="font-display uppercase text-xl tracking-wide text-white text-center lg:text-left">{p.title}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed text-center lg:text-left">{p.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
